import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const YearProjectionContainer = styled.div<{ hasBorder: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 50px;
  ${(props) =>
    props.hasBorder &&
    `border-top: 10px solid ${style((theme) => theme.colors.ivoryLight)};
  `}

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 50px 30px;
  }
`

export const ProjectionContainerHeading = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
`

export const StatsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0px;
`

export const StatsContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  align-items: center;
`

export const StatsColumnTitle = styled(Bodytext)<{
  color?: string
  isBold?: boolean
}>`
  font-size: 14px;
  line-height: 22px;
  color: ${(props) =>
    props.color ? props.color : style((theme) => theme.colors.stone)};
  font-weight: ${(props) => props.isBold && 600};
`

export const StatsColumnPercentage = styled(Heading)`
  font-size: 16px;
  line-height: 24px;
  color: ${style((theme) => theme.colors.slate)};
`

export const StatsContainerDivider = styled.hr`
  margin: 0px;
  border: 1px solid ${style((theme) => theme.colors.ivory)};
  height: 52px;
`

export const ProjectionContainerDisclaimer = styled(Bodytext)`
  font-size: 12px;
  line-height: 16px;
  color: ${style((theme) => theme.colors.stone)};
`

export const ProjectionDisclaimerLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
`

export const StatsPercentIconContainer = styled.div`
  display: flex;
`
export const StatsPercentIcon = styled(AcornsIcon)`
  margin-top: 5px;
  margin-right: 5px;
`
